var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.session && _vm.session.provider == 'amazon')?_c('b-button',{attrs:{"type":"is-light","id":"change-payment-amzn"}},[_vm._v(_vm._s(_vm.$t('payment.amazon-pay.change-paymenttype-on-amazon')))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }